import type { GADataProps } from "@typings/GA";
import type { MetaTagsProps } from "@typings/MetaTags";
import type { PageMetaDataValues } from "@typings/PageMetaData";

export default function SeasonalTagsMetaData(
  section: string,
  title: string,
  description: string,
  name: string,
): PageMetaDataValues {
  const metaTags: MetaTagsProps = {
    title,
    description,
    slug: section,
  };

  const gaData: GADataProps = {
    level2: section,
    title: `${name.replace(/\s+/g, "_")}_Index`,
    section: section,
    contentcat: "1",
    contenttype: "listing",
  };

  return {
    gaData,
    metaTags,
  };
}
